import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiHandle } from "../config/apiHandle/apiHandle";

// Get all app settings
export const getAppSettings = createAsyncThunk(
  "appSettings/getAppSettings",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiHandle.get("/admin/settings");
      return response.data;
    } catch (error) {
      console.log("error from get settings", error);
      if (error?.response?.data) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

// Save app settings
export const saveAppSettings = createAsyncThunk(
  "appSettings/saveAppSettings",
  async (settings, { rejectWithValue }) => {
    try {
      const response = await apiHandle.post("/admin/settings", settings);
      return response.data;
    } catch (error) {
      console.log("error from save settings", error);
      if (error?.response?.data) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);
